import { InformationTooltip, Tooltip, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import * as style from './RatingItem.css';
import info from './assets/info.svg';
import share from './assets/share.svg';
import classnames from 'classnames';

import { SubAccounts } from '../SubAccounts';
import { Position } from '../Position';
import { Socials } from '../Socials';
import { IAgency, IAgencyAccount, IMedal } from '../../../common/types/rating';
import { TSocials } from '../../../common/types/socials';

interface IRatingItemProps {
  logo: string;
  realAgency: IAgency;
  accounts: IAgencyAccount[];
  expandAgency: number | null;
  onExpandAgency?: (id: number) => void;
  isOpenedDescription: boolean;
  toggleDescr: VoidFunction;
  canExpanded: boolean;
  currentMedal?: IMedal;
  socials: TSocials[];
  coverage: string;
  link: string;
}

export const RatingItem: React.FC<IRatingItemProps> = ({
  realAgency,
  accounts,
  expandAgency,
  isOpenedDescription,
  toggleDescr,
  onExpandAgency,
  currentMedal,
  canExpanded,
  socials,
  coverage,
  logo,
  link,
}) => {
  const { userid, posShows, changePosition, nameGroup, experience, description } = realAgency;

  const haveSubAcc = accounts.length !== 0;

  const titleForRender = haveSubAcc ? (
    <div className={style['title-wrapper']}>
      <img className={style['logo']} src={logo} alt={nameGroup} />
      <div className={style['title']}>{nameGroup}</div>
    </div>
  ) : (
    <a
      className={classnames(style['link'], style['title-wrapper'])}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      onClick={e => e.stopPropagation()}
    >
      <img className={style['logo']} src={logo} alt={nameGroup} />
      <div className={style['title']}>{nameGroup}</div>
    </a>
  );

  const device = useDeviceType();

  return (
    <div className={style['item-container']}>
      <div
        className={classnames(
          style['item'],
          device === 'tablet' && style['item-tablet'],
          expandAgency === userid && style['item-expanded'],
        )}
        onClick={() => canExpanded && onExpandAgency && onExpandAgency(userid)}
      >
        <Position showsPosition={posShows} positionChange={changePosition} />
        <div className={style['name-container']}>{titleForRender}</div>

        <div className={style['shows-container']}>
          <div>{coverage}</div>
          {currentMedal && (
            <div className={style['medal-container']}>
              <Tooltip arrow={true} title={currentMedal.label} theme="white">
                <img src={info} className={style['medal-info']} />
              </Tooltip>
              <div className={style['medal']} />
            </div>
          )}
          <div className={style['icons-container']}>
            <div
              className={style['share-container']}
              onClick={(e: React.MouseEvent<HTMLElement>) => e.stopPropagation()}
            >
              <InformationTooltip arrow={true} header="Поделиться" content={<Socials socials={socials} />}>
                <img className={style['share-button']} src={share} />
              </InformationTooltip>
            </div>
            {canExpanded && (
              <div className={classnames(style['expand'], expandAgency === userid && style['expand-open'])} />
            )}
          </div>
        </div>
      </div>
      {canExpanded && (
        <div className={classnames(style['details'], expandAgency === userid && style['expanded'])}>
          <div className={style['details-wrapper']}>
            {experience && (
              <p>
                <span className={style['color-accent']}>Опыт работы:</span> с {experience} года.
              </p>
            )}
            <div className={style['descridivtion']}>
              {Array.isArray(description) ? description.map((item, key) => <div key={key}>{item}</div>) : description}
            </div>
            {description && (
              <button className={style['descr-button']} onClick={toggleDescr}>
                {isOpenedDescription ? 'свернуть' : 'читать далее'}
              </button>
            )}
          </div>
          {haveSubAcc && <SubAccounts list={accounts} />}
        </div>
      )}
    </div>
  );
};
